import { render, staticRenderFns } from "./PrePackingShipment.vue?vue&type=template&id=ee7c32d4"
import script from "./PrePackingShipment.vue?vue&type=script&lang=js"
export * from "./PrePackingShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports